import { Component } from '@angular/core';

/**
 * Author name: CISOMate
 * Date: 20/05/2026
 * Class Purpose: Empty shell for MSPM root route until brand name is resolved and navigation runs.
 * FR/Task ID: MSPM console errors fix
 * Pre-condition: App bootstrap complete.
 * Post-condition: Router can activate '' without redirecting to a missing :companyName param.
 */
@Component({
  selector: 'app-main',
  template: '',
  standalone: false,
})
export class MainComponent {}
